import { Permiso } from '@pages/colaboradores/@types/permisos.types';

export enum PermisosUsuario {
  suscripcion = 1,
  estadisticas_informes = 2,
  establecimientos_correlativos = 3,
  gestion_catalogo = 4,
  manejo_inventario = 5,
  manejo_clientes = 6,
  vista_bitacoras = 7,
  manejo_colaboradores = 8,
  configuracion_general = 9,
  // TODO: Remove ajustes basicos
  ajustes_basicos = 10,
  integraciones = 11,
  configuracion_caja = 12,
  margen_ganancia = 13,
  gestion_compras = 14,
  informacion_empresa = 15,
  ordenes_compra = 16,
  requisiciones = 17,
  facturas_compra = 18,
  documentos_aprobadores = 19,
  margen_ganancia_global = 20,
  modificar_config_global = 21,
  crear_orden_compra = 22,
  recibir_productos = 23,
  eliminar_orden_compra = 24,
  crear_requisicion = 25,
  enviar_recibir_productos = 26,
  eliminar_requisicion = 27,
  crear_factura_compra = 28,
  eliminar_factura_compra = 29,
  aprobar_orden_compra = 30,
  aprobar_requisicion = 31,
  ocultar_costos_margenes = 32
}

export enum PermisosEmpleado {
  ingreso_pos = 1,
  facturar = 2,
  pedidos = 4,
  clientes = 5,
  registrar_huellas = 6,
  config_impresoras = 7,
}

export enum PermisoCategorias {
  gestion_inventario = 1,
  informes_estadísticas = 2,
  administracion_cuenta = 3,
  administracion_empresa = 4,
  documentos_inventarioPro = 5,
  configuracion_inventarioPro = 6,
}

export enum EstadosPermisos {
  personalizado = -2,
  sin_acceso = -1,
  autorizado = 1,
  no_autorizado = 2, // Also "Restringido"
}

export interface InfoUsuario {
  NombreUsuario: string;
  NombreOrganizacion: string;
  NombreRol: string;
  Permisos: Partial<Permiso>[];
}
